import path from 'node:path';

export function normalizeSymbolIndexRelPath(parentPath: string, changedPath: string): string | null {
  const resolvedParent = path.resolve(parentPath);
  const abs = path.isAbsolute(changedPath) ? path.resolve(changedPath) : path.resolve(resolvedParent, changedPath);
  const rel = path.relative(resolvedParent, abs).replace(/\\/g, '/');
  if (rel.startsWith('..') || path.isAbsolute(rel)) return null;
  return rel;
}
